import { render, staticRenderFns } from "./ForgotPasswordVerifyCode.vue?vue&type=template&id=855da17a&scoped=true&"
import script from "./ForgotPasswordVerifyCode.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordVerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordVerifyCode.vue?vue&type=style&index=0&id=855da17a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855da17a",
  null
  
)

export default component.exports